import { render, staticRenderFns } from "./newAssetsInfo.vue?vue&type=template&id=3ebaee1e&scoped=true&"
import script from "./newAssetsInfo.vue?vue&type=script&lang=js&"
export * from "./newAssetsInfo.vue?vue&type=script&lang=js&"
import style0 from "./newAssetsInfo.vue?vue&type=style&index=0&id=3ebaee1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebaee1e",
  null
  
)

export default component.exports